import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import classes from "./OnboardingModalContent.module.css";
import { useSelector, useDispatch } from "react-redux";
import { obtInfoManagementActions } from "Store/obtInfoManagement";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

const OnboardingModalContent = (props) => {
  const details = useSelector((state) => state.obtInfoManagement);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(props.loading);
  }, [props.loading]);
  return (
    <>
      {loader ? (
        <div className={classes.loader}>
          <CircularProgress sx={{ color: "#A8A8A8" }} />
        </div>
      ) : null}
      <p className={classes.header}>
        On-boarding Guide Support
        <CloseIcon
          sx={{
            fontSize: "23px",
            marginLeft: "15rem",
            cursor: "pointer",
          }}
          onClick={props.onClose}
        ></CloseIcon>
      </p>
      <Grid container spacing={1} sx={{ marginTop: "10px" }}>
        <Grid className={classes.label} item xs={6}>
          <p>OG Supported</p>
        </Grid>
        <Grid item xs={12} sx={{ marginLeft: "none" }}>
          {" "}
          <Checkbox
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 25,
                color: "#3299FF",
              },
            }}
            checked={details.ogSupported}
            onChange={(e) => {
              dispatch(
                obtInfoManagementActions.toggleOgSupported(e.target.checked)
              );
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.label}>
          <p>Primary OG</p>
        </Grid>
        <Grid item xs={8} sx={{ marginBottom: "10px" }}>
          {" "}
          <TextField
            id="outlined-basic"
            variant="outlined"
            required
            className={classes.textfield}
            placeholder="Input"
            multiline
            rows={1}
            value={details.primaryOGs}
            onChange={(e) => {
              dispatch(obtInfoManagementActions.setPrimaryOGs(e.target.value));
            }}
            sx={{
              "& .MuiInputBase-input": {
                color: "#3f5765",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.label}>
          <p>Backup OG</p>
        </Grid>
        <Grid item xs={8} sx={{ marginBottom: "10px" }}>
          {" "}
          <TextField
            id="outlined-basic"
            variant="outlined"
            required
            placeholder="Input"
            multiline
            value={details.backupOGs}
            className={classes.textfield}
            onChange={(e) => {
              dispatch(obtInfoManagementActions.setBackupOGs(e.target.value));
            }}
            rows={1}
            sx={{
              "& .MuiInputBase-input": {
                color: "#3f5765",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.label}>
          <p>OG team email</p>
        </Grid>
        <Grid item xs={8} sx={{ marginBottom: "10px" }}>
          {" "}
          <TextField
            id="outlined-basic"
            variant="outlined"
            required
            placeholder="Input"
            multiline
            value={details.ogTeamEmail}
            onChange={(e) => {
              dispatch(obtInfoManagementActions.setOgTeamEmail(e.target.value));
            }}
            className={classes.textfield}
            rows={1}
            sx={{
              "& .MuiInputBase-input": {
                color: "#3f5765",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.label}>
          <p>OG Owner</p>
        </Grid>
        <Grid item xs={8} sx={{ marginBottom: "10px" }}>
          {" "}
          <TextField
            id="outlined-basic"
            variant="outlined"
            required
            placeholder="Input"
            multiline
            value={details.ogOwner}
            onChange={(e) => {
              dispatch(obtInfoManagementActions.setOgOwner(e.target.value));
            }}
            className={classes.textfield}
            rows={1}
            sx={{
              "& .MuiInputBase-input": {
                color: "#3f5765",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} className={classes.label}>
          <p>OG Escalation Point</p>
        </Grid>
        <Grid item xs={8} sx={{ marginBottom: "10px" }}>
          {" "}
          <TextField
            id="outlined-basic"
            variant="outlined"
            required
            placeholder="Input"
            multiline
            className={classes.textfield}
            rows={1}
            value={details.ogEscalationPoint}
            onChange={(e) => {
              dispatch(
                obtInfoManagementActions.setOgEscalationPoint(e.target.value)
              );
            }}
            sx={{
              "& .MuiInputBase-input": {
                color: "#3f5765",
              },
            }}
          />
        </Grid>
      </Grid>
      <div className={classes.buttonContainer}>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            borderColor: "#1a8cff",
          }}
          variant="outlined"
          onClick={props.onClose}
        >
          Cancel
        </Button>
        <Button
          sx={{
            textTransform: "none",
            borderRadius: "7px",
            backgroundColor: "#3299FF",
          }}
          variant="contained"
          onClick={props.handleSave}
          disabled={!props.isEdit}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default OnboardingModalContent;
